module.exports = __webpack_public_path__ + "static/media/usb-mini-silver.21e1bb08.svg";